export var AddressInputType;
(function (AddressInputType) {
    AddressInputType["googleMapPin"] = "google_map_pin";
    AddressInputType["formInput"] = "native_form_input";
})(AddressInputType || (AddressInputType = {}));
